import { render, staticRenderFns } from "./Semester.vue?vue&type=template&id=7bfeaf9b&scoped=true"
import script from "./Semester.vue?vue&type=script&lang=js"
export * from "./Semester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfeaf9b",
  null
  
)

export default component.exports